<template>
  <transition name="fade" appear>
  <div class="map-overlay">
    <div>
      <div>
        <img class="logo" src="@/assets/logos/detroit-lions.svg" alt="" />
        <button @click="$emit('close')">
          <svg
            width="24"
            height="25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M8.606 17.481 12 14.087l3.393 3.394 1.697-1.697-3.393-3.393 3.393-3.394L15.393 7.3 12 10.694 8.606 7.3 6.91 8.997l3.394 3.394-3.394 3.393 1.697 1.697Z"
              fill="#0076B6"
            />
            <path
              d="M12 24.39c6.617 0 12-5.383 12-12 0-6.616-5.383-12-12-12s-12 5.384-12 12c0 6.617 5.383 12 12 12Zm0-21.6c5.293 0 9.6 4.307 9.6 9.6 0 5.294-4.307 9.6-9.6 9.6-5.293 0-9.6-4.306-9.6-9.6 0-5.293 4.307-9.6 9.6-9.6Z"
              fill="#0076B6"
            />
          </svg>
        </button>
        <img class="map" src="@/assets/images/full-map.jpg" alt="" />
      </div>
    </div>
  </div>
  </transition>
</template>

<script>
</script>

<style lang="scss" scoped>
.map-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 100;
  display: flex;
  justify-content: center;
  align-items: center;
  > div {
    padding: 15px;        
    max-width: 1000px;
    background: #fff;
    overflow: hidden;
    border-top-right-radius: 40px;
    border-bottom-left-radius: 40px;
    @media (min-width:400px) {
      padding:45px;
    }
    > div {
      position: relative;
      padding-top:45px;
    }
  }
}
button {
  position: absolute;
  top: 0;
  right: 0;
  padding:20px;
}
.logo {
  position: absolute;
  top: 0;
  left: 0;
}
.map {
  width: 100%;
  max-height: 100vh;
  height: inherit;
  object-fit: contain;
  margin-top: 30px;
}
</style>